import { call, useAbortSignal } from "../deps.js";
export function* request(url, opts) {
    const signal = yield* useAbortSignal();
    const response = yield* call(fetch(url, { signal, ...opts }));
    return response;
}
export function* json(response) {
    const result = yield* call(response.json());
    return result;
}
//# sourceMappingURL=request.js.map